<template>
  <div style="align-items: flex-end">
    <b-table
      :dark="false"
      :hover="true"
      :striped="false"
      :bordered="true"
      :small="false"
      :fixed="false"
      :items="items"
      :busy="loading"
      responsive="sm"
      id="myHistory"
      :current-page="currentPage"
      :per-page="perPage"
      thead-class="header"
      class="mt-3"
      :fields="tableHeading"
      sort-by.sync="updatedAt"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      @filtered="onFilter"
    >
   <template slot="download" slot-scope="data">
                      <b-button
                        variant="primary"
                        @click="download(data.item.resultsFileUrl)"
                        >Download  <i class="fa fa-download" aria-hidden="true"></i>
                      </b-button>
                    </template>
    </b-table>
    <b-pagination
     style="float: right"
      v-model="currentPage"
      :total-rows="filterCount"
      :per-page="perPage"
      prev-text="Prev"
      next-text="Next"
      aria-controls="myHistory"
      hide-goto-end-buttons
    ></b-pagination>
  </div>
</template>

<script>
import { inventoryUpdateHistory } from "@/services/inventory";

export default {
  data() {
    return {
      title: "test",
      filterCount: 0,
      filter: "",
      currentPage: 1,
      perPage: 10,
      loading: false,
      sortBy: "updatedAt",
      sortDesc: true,
      tableHeading: [
        {
          key: "_id",
          label: "Request Id",
        },
        {
          key :"item.name",
          label: "Item Name"
        },
        {
          key: "entryType",
          label: "Type",
          sortable: true,
        },
        {
          key: "totalEntries",
          label: "Total Items",
          sortable: true,
        },
        {
          key: "successEntries",
          label: "Successful",
          sortable: true,
        },
        {
          key: "failedEntries",
          label: "Failed",
          sortable: true,
        },
        {
          key: "updatedAt",
          label: "Time",
          sortable: true,
        },
        {
          key: "download",
          label: "Download"
        },
      ],
      items: [],
    };
  },
  methods: {
    onFilter(list) {
      this.filterCount = list.length;
      this.currentPage = 1;
    },
      download(URL) {
      window.open(URL, "_blank");
    },
  },
  mounted() {
    this.loading = true;
    inventoryUpdateHistory()
      .then((data) => {
        console.log(data);
        this.loading = false;
        this.items = data.data;
      })
      .catch((er) => {
        this.loading = false;
      });
  },
};
</script>
